export async function setPollingOnce(
  action: () => void,
  condition: () => boolean,
) {
  let interval = 1;

  while (condition() === false) {
    interval = (interval + 1) * (Math.random() + 1);
    await new Promise((done) => setTimeout(done, interval));
  }

  action();
}
